module.exports = __webpack_public_path__ + "img/pub.b86af7fd.svg";